import PropTypes from "prop-types";
import {capitaliseFirst, you} from "./__strings";

export default function debts(props) {
    const betterProps = {...props, ...{you: you(props.applicant === 1 ? false : props.mortgage.applicant2?.firstName ? props.mortgage.applicant2.firstName:'the other applicant')}}
    return {
        name: `debts-${props.applicant}`,
        title: "Debts",
        link: `apply-${props.applicant}/debts`,
        personalisedTitle: capitaliseFirst(betterProps.you.your) + ' debt details',
        defaultLabel: "Debt",
        dynamicLabel: "lender",
        props: props,
        questions: [
            //TODO: Other financial commitments not covered in this application

            //TODO: Merge Credit Cards and Store Cards
            debtType(betterProps),
            lender(betterProps),
            creditLimit(betterProps),
            outstanding(betterProps),
            monthlyPayment(betterProps),
            inArrears(betterProps),
            arrears(betterProps),
            endDate(betterProps),
            clearedBeforeMortgage(betterProps),
            //TODO: make account number optional
            accountNumber(betterProps)
        ]
    }
}

export function accountNumber(props) {
    return {
        text: "What is the account number related to this debt",
        label: "Account number",
        name: "accountNumber",
        answer: {
            type: "text",
            optional: true,
        },
        hides: {
            debtType: (v) => {
                return v !== "LOAN"
            }
        },
        model: "debts"
    }
}
export function debtType(props) {


    return {
        text: "What type of debt is this?",
        label: "Debt Type",
        name: "debtType",
        answer: {
            type: "choice",
            choices: [
                {value: 'CREDITCARD', text: "Credit or Store Card"},
                // {value: 'STORECARD', text: "Store Card"},
                {value: 'LOAN', text: "Loan"},
                {value: 'OVERDRAFT', text: "Overdraft"},
            ]
        },
        model: "debts"
    }
}
export function lender(props) {
    return {
        text: {
            debtType: {
                'LOAN': "Who issued " + props.you.you + " with this loan?",
                'CREDITCARD': "Who issued " + props.you.you + " with this credit card?",
                'STORECARD': "Who issued " + props.you.you + " with this store card?",
                'OVERDRAFT': "Who issued " + props.you.you + " with this overdraft?",
            }
        },
        label: "Lender",
        name: "lender",
        answer: {
            type: "text",
        },
        model: "debts"
    }
}
export function creditLimit(props) {
    return {
        label: "Credit Limit",
        text: {
            debtType: {
                'LOAN': "What was the original amount of this loan",
                'CREDITCARD': "What is the credit limit on this credit card?",
                'STORECARD': "What is the credit limit on this store card?",
                'OVERDRAFT': "What is the overdraft limit on this account?",
            }
        },
        name: "creditLimit",
        answer: {
            type: "euro",
            validation: {
                min: {value: 1, message: "This must be a value greater than €1"},
                max: {value: 10000000, message: "You probably don't need a mortgage"}
            }
        },
        model: "debts"
    }
}
export function outstanding(props) {
    return {
        label: "Outstanding Amount",
        text: {
            debtType: {
                'LOAN': "What is the outstanding amount on this loan",
                'CREDITCARD': "What is the outstanding amount on this credit card?",
                'STORECARD': "What is the outstanding amount on this store card?",
                'OVERDRAFT': "What is the outstanding amount on this overdraft?",
            }
        },
        name: "outstanding",
        answer: {
            type: "euro",
            validation: {
                min: {value: 0, message: "This must be a value greater than €0"},
                max: {value: 10000000, message: "You probably don't need a mortgage"}
            },
            optional: true
        },
        hides: {
            debtType: (v) => {
                return v === "OVERDRAFT"
            }
        },
        model: "debts"
    }
}
export function monthlyPayment(props) {
    return {
        label: "Monthly Repayments",
        text: {
            debtType: {
                'LOAN': "What is the monthly repayment on this loan",
                'CREDITCARD': "What is the typical monthly payment on this card?",
                'STORECARD': "What is the monthly repayment on this store card?",
                'OVERDRAFT': "What is the monthly repayment on this overdraft?",
            }
        },
        name: "monthlyPayment",
        answer: {
            type: "euro",
            validation: {
                min: {value: 1, message: "This must be a value greater than €1"},
                max: {value: 10000000, message: "You probably don't need a mortgage"}
            }
        },
        hides: {
            debtType: (v) => {
                return v === "OVERDRAFT"
            }
        },
        model: "debts"
    }
}
export function inArrears(props) {
    return {
        text: {
            debtType: {
                'LOAN': capitaliseFirst(props.you.areYou) + " in arrears on this loan?",
                'CREDITCARD': capitaliseFirst(props.you.areYou) + " in arrears on this credit card?",
                'STORECARD': capitaliseFirst(props.you.areYou) + " in arrears on this store card?",
                'OVERDRAFT': capitaliseFirst(props.you.areYou) + " in arrears on this overdraft?",
            }
        },
        label: "In Arrears",
        name: "inArrears",
        answer: {
            type: "choice",
            choices: [
                {value: true, text: "Yes"},
                {value: false, text: "No"}
            ]
        },
        hides: {
            debtType: (v) => {
                return v === "OVERDRAFT"
            }
        },
        model: "debts"
    }
}
export function arrears(props) {
    return {
        label: "Arrears",
        text: "By how much " + props.you.areYou + " in arrears?",
        name: "arrears",
        answer: {
            type: "euro",
            validation: {
                min: {value: 1, message: "This must be a value greater than €1"},
                max: {value: 10000000, message: "You probably don't need a mortgage"}
            }
        },
        hides:{
            debtType: (v) => {
                return v === "OVERDRAFT"
            },
            inArrears:(v)=>{return v!==true }

        },
        model: "debts"
    }
}
export function endDate(props) {
    return {
        text: {
            debtType: {
                'LOAN': "On what date will this loan be repaid in full?",
                'CREDITCARD': "By what date will this credit card be cleared?",
                'STORECARD': "By what date will this store card be cleared?",
                'OVERDRAFT': "By what date will this overdraft be cleared?",
            }
        },
        label: "End Date",
        name: "endDate",
        answer: {
            type: "mmyyyy",
            validation: {
                min: {value: new Date(), message: "The date must be in the future"}
            },
        },

        hides:{
            debtType: (v) => {
                return v === "OVERDRAFT"
            }
        },
        model: "debts"
    }
}
export function clearedBeforeMortgage(props) {
    return {
        text: "Will "+props.you.you+" clear this debt before your final approval?",
        label: "Cleared before mortgage",
        name: "clearedBeforeMortgage",
        answer: {
            type: "choice",
            choices: [
                {value: true, text: "Yes"},
                {value: false, text: "No"}
            ]
        },
        hides:{
            debtType: (v) => {
                return v === "OVERDRAFT"
            }
        },
        model: "debts"
    }
}

debts.propTypes = {
    applicant: PropTypes.number
}


